<template>
  <nv-page header="IOS Bundle Discovery" data-cy="ios-bundle-discovery">
    <template #toolbar>
      <v-spacer />
      <nv-btn
        v-if="items.length && $auth.hasPermissions('ant.discovery')"
        type="lock"
        data-cy="lock-btn"
        @click="reserve()"
      />
      <nv-table-search v-model="search" sync class="ml-4" data-cy="search" />
    </template>

    <template #filters>
      <nv-table-filters
        ref="applied-filters"
        :value="formattedFilters"
        :no-clear="isDefaultFilters"
        @clear="$refs['filter-sheet'].clearFilters()"
      >
        <filter-sheet ref="filter-sheet" @changed="setTableFilters" />
      </nv-table-filters>
    </template>

    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      :options.sync="table"
      :server-items-length="totalItems"
      :footer-props="footerProps"
      :items-per-page.sync="table.itemsPerPage"
      must-sort
    >
      <template #item="{ item }">
        <tr>
          <td>{{ item.bundle_id }}</td>
          <td>{{ item.countries.join(', ') | uppercase }}</td>
          <td>{{ item.hits | number }}</td>
          <td>{{ item.last_seen_on | date }}</td>
        </tr>
      </template>
    </v-data-table>
  </nv-page>
</template>

<script>
import FilterSheet from '@/components/cls/FilterSheet';
import DiscoveryList from '@/components/cls/DiscoveryList';

const headers = [
  { text: 'Bundle ID', sortable: false, value: 'package_id' },
  { text: 'Countries', sortable: false, value: 'countries' },
  { text: 'Audience', sortable: false, value: 'rank' },
  { text: 'Last Seen', sortable: false, value: 'last_seen_on' },
];

export default {
  components: { FilterSheet },
  extends: DiscoveryList('ios/bundle'),
  data: () => ({
    headers,
  }),
};
</script>
